import filterChange from './filterChange';

const filterApplyBackup = (filterType, dispatch, getState) => {
  const {form: {searchFilters}} = getState();
  const backupKey = filterType + 'Backup'
  if (backupKey in searchFilters) {
    dispatch(filterChange(filterType, searchFilters[backupKey]))
  }
  return true
}

export default (filterType) => (dispatch, getState) => filterApplyBackup(filterType, dispatch, getState)
